import { Component, OnInit, Inject } from '@angular/core';
import { AuthFacade } from '@cigna/chcp/auth/data-access';
import { FeatureTogglesFacade } from '@cigna/features';
import {
  ENVIRONMENT_CONFIG,
  EnvironmentConfig,
} from '@cigna/chcp/shared/environment-util';
@Component({
  selector: 'cigna-precertification',
  templateUrl: './precert.component.html',
  styleUrls: ['./precert.component.scss'],
})
export class PrecertificationComponent implements OnInit {
  isImpersonator$ = this.authFacade.isImpersonator$;
  isPilotMHKUser$ = this.featureToggleFacade.featuresEnabled(['pilotMHKUser']);
  mhkUrl: string | undefined;

  constructor(
    private authFacade: AuthFacade,
    private featureToggleFacade: FeatureTogglesFacade,
    @Inject(ENVIRONMENT_CONFIG) public envConfig: EnvironmentConfig,
  ) {}

  ngOnInit() {
    this.mhkUrl = this.envConfig.redirect.mhk;
  }
}
